module.exports = __webpack_public_path__ + "walking_white.svg?d825080d2acea9f8aa4af4cfc68cc606";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/walking_white.svg
// module id = 57
// module chunks = 0